import SwipeableNewsList from 'app/components/topNewsModule/subNews/SwipeableNewsList';
import React, { useCallback } from 'react';
import { NewsPerView } from 'app/components/topNewsModule/models/NewsPerView';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import { useMediaQuery } from '@mui/material';
import { streamModuleViewsBreakpoint } from 'app/styles/media';
import StaticNewsList from 'app/components/topNewsModule/subNews/NewsView';
import NewsListPlaceholder from 'app/components/topNewsModule/subNews/NewsListPlaceholder';
export default function ResponsiveNewsList(_ref) {
  let {
    newsList
  } = _ref;
  const {
    updateTrackingData
  } = useDistrictMainPageTracking();
  const isMobile = useMediaQuery("(max-width: ".concat(streamModuleViewsBreakpoint, "px)"));
  const updateTracking = useCallback(data => updateTrackingData(DistrictMainPageModuleType.TOPNEWS, data), [updateTrackingData]);
  if (!newsList.length) {
    return /*#__PURE__*/React.createElement(NewsListPlaceholder, null);
  }
  if (newsList.length <= (isMobile ? NewsPerView.Small : NewsPerView.Large)) {
    return /*#__PURE__*/React.createElement(StaticNewsList, {
      news: newsList,
      listLength: isMobile ? NewsPerView.Small : NewsPerView.Large
    });
  }
  return /*#__PURE__*/React.createElement(SwipeableNewsList, {
    newsList: newsList,
    newsPerView: isMobile ? NewsPerView.Small : NewsPerView.Large,
    updateTrackingData: updateTracking,
    "data-sentry-element": "SwipeableNewsList",
    "data-sentry-component": "ResponsiveNewsList",
    "data-sentry-source-file": "ResponsiveNewsList.tsx"
  });
}